module.exports = __webpack_public_path__ + "static/media/eighteenseventyeight.b99f4030.png";